// extracted by mini-css-extract-plugin
module.exports = {"pickupIndicator":"StopsSkeletonCell_pickupIndicator__ZCmps","deliveryIndicator":"StopsSkeletonCell_deliveryIndicator__BApk0"};